import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchPriceLevelDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'price_level/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function savePriceLevel(app, dataToSave) {
  const { user={}, data } = dataToSave;
  let priceLevelData = {
    doc_type: DocType.PRICE_LEVEL,
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    active: util.toBoolean(data.active),
    loyalty_multiplier: util.toNumber(data.loyalty_multiplier),
    system_defined: util.toBoolean(data.system_defined)
  };
  return common.saveDoc(app, {
    source: data,
    doc: priceLevelData,
    user,
  });
}

export function deletePriceLevel(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.PRICE_LEVEL
  });
}

export function fetchPriceLevelById(app, params) {
  const { id } = params;
  const docType = DocType.PRICE_LEVEL;
  return common.getDoc(app, { id, docType });
}
